import { useCallback, useRef } from "react";

/**
 * Возвращает стабильную по ссылке обёртку над переданным колбэком.
 * При вызове обёртки всегда выполняется последняя версия колбэка.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useLatestCallback<T extends (...args: any[]) => any>(callback: T): T;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useLatestCallback<T extends (...args: any[]) => any>(callback: T | undefined): T | undefined;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useLatestCallback<T extends (...args: any[]) => any>(callback: T | undefined): T | undefined {
    const ref = useRef(callback);
    ref.current = callback;

    const stable = useCallback((...args: Parameters<T>) => ref.current?.(...args) as ReturnType<T>, []) as T;

    return callback !== undefined ? stable : undefined;
}
